import Vue from 'vue'
import {
  Pagination,
  Button, Tabs, TabPane, Carousel, CarouselItem, Breadcrumb,
  BreadcrumbItem, Input, Image, Empty
} from 'element-ui'

Vue.use(Pagination)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Input)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Image)
Vue.use(Empty)
